import styled from "@emotion/styled";
export const FlyoutContainer = styled("div")`
    background-color: transparent;
    isolation: isolate;
`;
//# sourceMappingURL=FlyoutContainer.js.map